import React from 'react';
import { Badge, Card, Table } from 'react-bootstrap';
export default function ClaimerPreviewExpenditure(_ref) {
  let {
    aifReportData
  } = _ref;
  const {
    submission_configuration,
    aif_model,
    external_id
  } = aifReportData;
  const formatDate = dateString => {
    return new Date(dateString).toLocaleDateString('en-GB');
  };
  const formatCurrency = amount => {
    if (!amount) return '£0';
    const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(numAmount);
  };
  return /*#__PURE__*/React.createElement(Card, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Card.Header, {
    className: "bg-dark text-white"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "mb-0"
  }, "Expenditure")), /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, "Expenditure in UK:"), " ", /*#__PURE__*/React.createElement(Badge, {
    bg: aif_model.expenditure.expenditure_in_uk ? 'success' : 'danger'
  }, aif_model.expenditure.expenditure_in_uk ? 'Yes' : 'No')), aif_model.expenditure.expenditure_by_accounting_period.map((period, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    className: "mb-4"
  }, /*#__PURE__*/React.createElement("h6", {
    className: "text-primary"
  }, "Accounting Period: ", formatDate(period.accounting_period.start), " - ", formatDate(period.accounting_period.end)), period.sme && /*#__PURE__*/React.createElement("div", {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement("h6", null, "SME Expenditure"), /*#__PURE__*/React.createElement(Table, {
    striped: true,
    bordered: true,
    hover: true,
    size: "sm"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Category"), /*#__PURE__*/React.createElement("th", {
    className: "text-end"
  }, "Amount"))), /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, "Staff"), /*#__PURE__*/React.createElement("td", {
    className: "text-end"
  }, formatCurrency(period.sme.qualifying_expenditure_breakdown.staff))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, "Contractors"), /*#__PURE__*/React.createElement("td", {
    className: "text-end"
  }, formatCurrency(period.sme.qualifying_expenditure_breakdown.contractors.total))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, "Consumables"), /*#__PURE__*/React.createElement("td", {
    className: "text-end"
  }, formatCurrency(period.sme.qualifying_expenditure_breakdown.consumables))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, "Software"), /*#__PURE__*/React.createElement("td", {
    className: "text-end"
  }, formatCurrency(period.sme.qualifying_expenditure_breakdown.software))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, "Cloud Computing"), /*#__PURE__*/React.createElement("td", {
    className: "text-end"
  }, formatCurrency(period.sme.qualifying_expenditure_breakdown.cloud_computing))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, "Data Licences"), /*#__PURE__*/React.createElement("td", {
    className: "text-end"
  }, formatCurrency(period.sme.qualifying_expenditure_breakdown.data_licences))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, "Externally Provided Workers"), /*#__PURE__*/React.createElement("td", {
    className: "text-end"
  }, formatCurrency(period.sme.qualifying_expenditure_breakdown.externally_provided_workers.total))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, "Indirect Activities"), /*#__PURE__*/React.createElement("td", {
    className: "text-end"
  }, formatCurrency(period.sme.qualifying_expenditure_breakdown.indirect_activities))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, "Independent Research Contributions"), /*#__PURE__*/React.createElement("td", {
    className: "text-end"
  }, formatCurrency(period.sme.qualifying_expenditure_breakdown.contributions_to_independent_research))))), period.sme.projects && period.sme.projects.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "mt-3"
  }, /*#__PURE__*/React.createElement("h6", null, "Project Breakdown"), /*#__PURE__*/React.createElement(Table, {
    striped: true,
    bordered: true,
    hover: true,
    size: "sm"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Project Number"), /*#__PURE__*/React.createElement("th", {
    className: "text-end"
  }, "Amount"))), /*#__PURE__*/React.createElement("tbody", null, period.sme.projects.map((project, pIndex) => /*#__PURE__*/React.createElement("tr", {
    key: pIndex
  }, /*#__PURE__*/React.createElement("td", null, "Project ", project.project_number), /*#__PURE__*/React.createElement("td", {
    className: "text-end"
  }, formatCurrency(project.amount))))))))))));
}